export default "__VITE_ASSET__qF8PhhXq__"